// import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import WelcomePage from './Components/WelcomePage';
import SelectLanguagePage from './Components/SelectLanguagePage';
import RegistrationForm from './Components/RegistrationForm';
import VerifyOtpPage from './Components/VerifyOtpPage';
import Login from './Components/Login';
import WellnessGuidancePage from './Components/WellnessGuidancePage';
import HealthLogPage from './Components/HealthLogPage';
import FaceScan from './Components/FaceScan';
import HealthStoryPage from './Components/HealthStoryPage';
import Privacy from './Components/Privacy';
import NotFound from './Components/NotFound';
import PrivateRoute from './PrivateRoute';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<WelcomePage />} />
      <Route path="/language" element={<SelectLanguagePage />} />
      <Route path="/registration" element={<RegistrationForm />} />
      <Route path="/verify-otp" element={<VerifyOtpPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/privacy" element={<Privacy />} />
      

      {/* Protected Routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/wellness-guidance" element={<WellnessGuidancePage />} />
        <Route path="/health-log" element={<HealthLogPage />} />
        <Route path="/scan" element={<FaceScan />} />
        <Route path="/health-report" element={<HealthStoryPage />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
